import { InjectionToken } from '@angular/core';

export const INSTRUMENTATION_QUEUE = new InjectionToken<Array<QueuedAppEvent>>('INSTRUMENTATION_QUEUE');
